<template>
    <div class="container" :class="{ 'with-right-slot': $slots.headerRight }">
        <div class="app-data-wrap">
            <div class="content">
                <img class="app-icon" :src="appIcon" :alt="appName" />
                <span class="platform-wrap" v-if="platform">
                    <Platform :platform="platform" class="platformIcon"></Platform>
                </span>
                <div class="app-details">
                    <span v-if="appId" class="font-2 app-id">{{ appId }}</span>
                    <Tooltip :text="appName" class="font-3 app-name">
                        {{ appName }}
                    </Tooltip>
                    <div class="relative-wrap">
                        <div class="subHeader">
                            <slot name="subHeader">
                                <span class="font-9 appKey">
                                    APP KEY: {{ appKey }}
                                </span>
                            </slot>
                            <slot name="appActions">
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <slot name="headerRight"></slot>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';
import consts from 'services/metaData/consts';
import Platform from 'components/appHeader/Platform.vue';

export default {
    name: 'AppHeader',
    components: { Platform, Tooltip, IconBase },
    props: {
        platform: {
            type: String,
            validator: (val) => ['android', 'ios'].includes(val)
        },
        appKey: String,
        appId: Number,
        appName: String,
        appIcon: String
    },
    data() {
        return {
            consts
        };
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";
    $tabsHeaderBackground: $white;
    $tabs-horizontalPaddingSize:15px;
    $disabledTabFont: $light-600;
    $subHeaderFontColor: $light-800;
    $titleText: $dark-300;
    $headerIconSize: 41px;

    .container {
        max-width: 1100px;
        width: 100%;
        margin: 0 auto 0 0;
        padding-right: 10px;
        padding-left: 10px;

        &.with-right-slot {
            display: grid;
            grid-template-columns: auto auto;
        }
    }

    .app-id {
        color: $subHeaderFontColor;
        display: inline-block;
        line-height: 23px;
        vertical-align: middle;
    }

    .content {
        position:relative;
        padding-left: $headerIconSize + $tabs-horizontalPaddingSize; // $headerIconSize + $tabs-horizontalPaddingSize;
        padding-top: 2px;
    }
    .app-icon {
        width: $headerIconSize;
        height: $headerIconSize;
        position: absolute;
        border-radius: 4px;
        top:0;
        left:0;
    }
    .app-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: $titleText;
        display: block;
        line-height: 23px;
        padding-right: 50px;
        vertical-align: middle;
        margin-bottom: 2px;
    }
    .appKey {
        color:$subHeaderFontColor;
        background-color: $light-300;
        padding: 2px 4px;
        border-radius: 3px;
        margin-top: 6px;
    }
    .details {
        margin-left: -2px;
        .relative-wrap{
            margin-top: 2px;
        }
    }
    .platform-wrap {
        position: absolute;
        padding: 2px 3px;
        left: 29px;
        top: 27px;
        background-color: white;
        border-radius: 10px;
    }

    .app-data-wrap {
        padding: 13px 0 12px 2px;
        min-height: 63px;
    }

    .app-details {
        margin-top: -4px;
    }
</style>
